import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ id, image, title, date, excerpt, author }) => {
  return (
    <div className="bg-white overflow-hidden transition-shadow duration-300">
      <div className="w-full h-56 bg-gray-100 flex items-center justify-center">
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </div>
      <div className="p-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{title}</h2>
        <p className="text-gray-500 text-sm mb-3">
          {date} • {author}
        </p>
        <p className="text-gray-700 text-sm text-justify mb-4">{excerpt}</p>

        <Link
          to={`/blog/${id}`}
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Read More →
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
